export default __webpack_public_path__ + "static/media/smp-logo.b7d19491.png";